export enum routes {
  // AUTH (customer)
  LOGIN = '/login',
  REGISTER = '/register',
  ACTIVATE = '/activate/:token',
  REQUEST_NEW_PASSWORD = '/new-password',
  RESET_PASSWORD = '/reset/:token',

  // AUTH (sales)
  LOGIN_SALES = '/sales/login',
  ACTIVATE_SALES = '/sales/activate/:token',
  REQUEST_NEW_PASSWORD_SALES = '/sales/new-password',
  RESET_PASSWORD_SALES = '/sales/reset/:token',

  // AUTH (superuser)
  LOGIN_SUPER_USER = '/superuser/login',
  ACTIVATE_SUPER_USER = '/superuser/activate/:token',
  REQUEST_NEW_PASSWORD_SUPER_USER = '/superuser/new-password',
  RESET_PASSWORD_SUPER_USER = '/superuser/reset/:token',

  // CUSTOMER/PRODUCER PORTAL
  ACCOUNT_SELECTION = '/accounts',
  CUSTOMER_EMAIL = '/customer-email',

  MORE = '/more',

  OVERVIEW = '/overview',
  PRODUCER = '/producer',

  ADDRESSES = '/addresses', // Old route that redirects to /contract
  ADDRESS_DETAIL = '/addresses/:id', // Old route that redirects to /contract

  BILLING = '/billing',
  BILLING_INVOICES = '/billing/invoices',
  BILLING_INSTALMENT = '/billing/instalment',
  BILLING_EDIT_INSTALMENT = '/billing/instalment/edit',
  BILLING_SETTLEMENT = '/billing/settlement',
  BILLING_CYCLES = '/billing/billing-cycles',
  BILLING_CYCLE_DETAIL = '/billing/billing-cycles/:id',
  BILLING_INSTALMENT_CHECK = '/billing/billing-cycles/current', // Keep in sync with BILLING_CYCLE_DETAIL with a static id (current)

  CONTRACT = '/contract',
  CONTRACT_DETAIL = '/contract/:id',

  CONSUMPTION = '/consumption',
  CONSUMPTION_ELECTRICITY = '/consumption/electricity',
  CONSUMPTION_GAS = '/consumption/gas',
  CONSUMPTION_METER_READINGS = '/consumption/meter-readings',
  CONSUMPTION_EDIT_METER_READINGS = '/consumption/meter-readings/edit',
  CONSUMPTION_PRICE_HISTORY = '/consumption/price-history',

  SWITCH_TO_FIX = '/switch-to-fix',

  MARKET_PRICES = '/market-prices',

  GUARANTEE_OF_ORIGIN = '/guarantee-of-origin',
  GUARANTEE_OF_ORIGIN_STATUS = '/guarantee-of-origin/status',

  ENERGY_OVERVIEW = '/energy-overview',

  REFERRAL = '/referral',
  REFERRAL_FRIENDS = '/referral/friends',
  REFERRAL_INFO = '/referral/info',

  USER = '/user',
  USER_PERSONAL = '/user/personal',
  USER_EDIT_PERSONAL = '/user/personal/edit',
  USER_CONTACT = '/user/contact',
  USER_EDIT_CONTACT = '/user/contact/edit',
  USER_PAYMENT = '/user/payment',
  USER_EDIT_PAYMENT = '/user/payment/edit',
  USER_LOGIN_DETAILS = '/user/login-details',
  USER_LOGIN_DETAILS_EDIT = '/user/login-details/edit',

  MOVE = '/move',

  SUPPORT = '/support',
  SUPPORT_FAQ = '/support/faq',
  SUPPORT_CONTACT = '/support/contact',
  SUPPORT_COMPLAINT = '/support/complaint',
  SUPPORT_COMPLAINT_FORM = '/support/complaint/new',

  EVENT_LOG = '/event-log',

  CONTRACTS = '/contracts',
  CONTRACTS_ADD = '/contracts/add',
  CONTRACTS_MOVE = '/contracts/move',
  CONTRACTS_TERMINATE = '/contracts/terminate',

  // DIRECT NAVIGATION
  CANCEL_SUPPLIER_SWITCH = '/cancel-supplier-switch',
  MYSTERY_SWITCH = '/mystery-switch',

  // SUPERUSER ONLY
  TARIFFS = '/tariffs',
  TARIFFS_OVERVIEW = '/tariffs/overview',
  TARIFFS_PRODUCTS = '/tariffs/products',
  TARIFFS_DISCOUNTS = '/tariffs/discounts',

  // SALES ROUTES
  SALES_HOME = '/sales/home',
  SALES_CONTRACTS_ADD = '/sales/contracts/add',
  SALES_DETAILS = '/sales/details/:contactId',
  SALES_DASHBOARD = '/sales/dashboard',
  SALES_EVENTS = '/sales/events'
}
